export type { ExcelExportDialogProps as BaseDialogProps } from '../ExcelExportDialog/types';
export type { ExcelExportFormValues } from '../ExcelExportDialog/types';
export type { ExcelExportContextValues as ExcelExportContextType } from 'common/types/store';

export const SHARED_EXPORT_OPTIONS = {
  OTHER: 'other',
} as const;

export type SharedExportOption = (typeof SHARED_EXPORT_OPTIONS)[keyof typeof SHARED_EXPORT_OPTIONS];

export interface BaseExcelExportDialogErrors {
  [key: string]: string[] | undefined;
}

export interface BaseHasData {
  [key: string]: boolean;
}

export interface BaseCurrentSelectedValues {
  [key: string]: number | undefined;
}

export interface BaseOtherOptions {
  [key: string]: boolean;
}
